// Seed colours and labels straight from packages/ui/DESIGN.md ("ต้นฉบับของสี" table) — colours come
// from one place. `BRAND_HEX` is imported live from @preedanext/ui/tokens (generated by
// packages/ui/tokens/build-m3.mjs) rather than copied by hand, so this list cannot drift from the
// same table every other surface reads; only the label, id and manifest.json keyPrefixes are this
// file's own. `personal` is BRAND_HEX.personal, not a hand-picked hex — 29/09/2569's colour-clash
// fix (group/preedanext, preedagroup and personal all read the same #B50D29 before this) depends on
// that being a live import, not a copy someone could re-diverge.
import { BRAND_HEX } from "@preedanext/ui/tokens";

export interface BrandInfo {
  id: string;
  label: { th: string; en: string };
  seed: string;
  /** The brand/companies/<slug>/ and content/<slug>/ path fragment this maps to in manifest.json. */
  keyPrefixes: string[];
}

export const BRANDS: readonly BrandInfo[] = [
  {
    id: "preedanext",
    label: { th: "PREEDA NEXT", en: "PREEDA NEXT" },
    seed: BRAND_HEX.preedaNext,
    keyPrefixes: ["preeda-next", "preedanext"],
  },
  {
    id: "pk",
    label: { th: "PK Pro Klasse", en: "PK Pro Klasse" },
    seed: BRAND_HEX.pk,
    keyPrefixes: ["pk-pro-klasse", "pk-pro-lab", "pk-pro-work"],
  },
  {
    id: "sp",
    label: { th: "SP Ban Carcare", en: "SP Ban Carcare" },
    seed: BRAND_HEX.sp,
    keyPrefixes: ["sp-ban-carcare", "sp-baan-carcare"],
  },
  {
    id: "personal",
    label: { th: "tanakritkhajornkovit.com", en: "tanakritkhajornkovit.com" },
    seed: BRAND_HEX.personal,
    keyPrefixes: ["personal", "tanakrit"],
  },
  {
    id: "spms",
    label: { th: "SPMS", en: "SPMS" },
    // The SPMS logo red, not BRAND_HEX.spms — that constant seeds the old --color-red-spms-* ramp
    // the hub's Office pages still use and is not the SPMS brand mark (packages/ui/DESIGN.md).
    seed: BRAND_HEX.spmsLogo,
    keyPrefixes: ["spms"],
  },
  {
    id: "est",
    label: { th: "EST", en: "EST" },
    seed: BRAND_HEX.est,
    keyPrefixes: ["est"],
  },
  {
    id: "preedagroup",
    label: { th: "Preeda Group", en: "Preeda Group" },
    seed: BRAND_HEX.preedaGroup,
    keyPrefixes: ["preeda-group"],
  },
  {
    id: "cpk",
    label: { th: "CPK", en: "CPK" },
    seed: BRAND_HEX.cpk,
    keyPrefixes: ["cpk"],
  },
];

export function brandLabel(id: string | null, lang: "th" | "en"): string {
  if (!id) return lang === "th" ? "ไม่ระบุแบรนด์" : "Unassigned";
  const found = BRANDS.find((b) => b.id === id || b.keyPrefixes.includes(id));
  return found ? found.label[lang] : id;
}

/** Matches a manifest item's `brand` field (a raw path slug) back to one of the six-plus identities. */
export function resolveBrandId(rawBrand: string | null): string | null {
  if (!rawBrand) return null;
  const found = BRANDS.find(
    (b) => b.id === rawBrand || b.keyPrefixes.includes(rawBrand),
  );
  return found ? found.id : rawBrand;
}
